module.exports = __webpack_public_path__ + "img/base_inside_bw.5c568221.png";